import { makeApiRequest } from "../httpService";
// eslint-disable-next-line no-unused-vars
import { DetailedAuditSearchMessage } from "./models/DetailedAuditSearchMessage";
// eslint-disable-next-line no-unused-vars
import { DetailedAuditTrailsMessage } from "./models/DetailedAuditTrailsMessage";
// eslint-disable-next-line no-unused-vars
import { AuditDetailMessage } from "./models/AuditDetailMessage";

export * from "./models/DetailedAuditTrailMessage";
export * from "./models/DetailedAuditTrailsMessage";
export * from "./models/DetailedAuditSearchMessage";
export * from "./models/AuditDetailMessage";
export * from "./models/AuditUserMessage";

export const getDetailedAudits = async (
  searchCriteria: DetailedAuditSearchMessage
) => {
  const result = await makeApiRequest<DetailedAuditSearchMessage, DetailedAuditTrailsMessage>(
    "/detailedAudits",
    "POST",
    searchCriteria
  );
  return result;
};

export const getDetailedAuditRecords = async (
  detailedAuditId: number
) => {
  const url = `/detailedAuditRecords?detailedAuditId=${detailedAuditId}`;
  const result = await makeApiRequest<void, Array<AuditDetailMessage>>(
    url,
    "GET"
  );
  return result;
};
